import { Box } from '@mui/material';

const RequiredMarker = () => {
    return (
        <Box
            component="span"
            sx={{ color: (theme) => theme.palette.error.main }}
        >
            *
        </Box>
    );
};

export default RequiredMarker;
